import {safeUnreachableCase} from '~/utils/unreachableCase'
import HgArticleHeroNoAsset, {
  type HgArticleHeroNoAssetProps,
} from '../HgArticleHeroNoAsset'
import HgArticleHeroLowVariantComponents, {
  type HgArticleHeroLowVariantProps,
} from './HgArticleHeroLowVariantComponents'

type HgArticleHeroLowVariants =
  | HgArticleHeroLowVariantProps
  | HgArticleHeroNoAssetProps

export type HgArticleHeroLowProps = {
  level: 'low'
} & HgArticleHeroLowVariants

export default function HgArticleHeroLow(props: HgArticleHeroLowProps) {
  switch (props.assetType) {
    case 'horizontal':
    case 'vertical':
    case 'square':
      return <HgArticleHeroLowVariantComponents {...props} />
    case 'none':
      return <HgArticleHeroNoAsset {...props} />
    default:
      return safeUnreachableCase(props, null)
  }
}
